import './_media';
import './_header';
import './_search';
import scrollToBlocks from './_scrollTo';
import '/src/js/modules/_feedback.js'
import contentInit from '../modules/_content';

window.addEventListener('DOMContentLoaded', function() {
    contentInit();
    scrollToBlocks();
})